import { Grid, Stack, Text, Title } from '@mantine/core';

import { TransitControlNotificationType, TransitControlType, TransitInControl, TransitRequestDocumentType } from '@e-origin/shared';

interface ControlNotificationProps {
  inControl: TransitInControl;
}

export const ControlNotification = ({ inControl }: ControlNotificationProps) => {
  return (
    <Stack gap="xl" mb="md">
      <Title order={5} fw={600}>
        Control notification
      </Title>
      <Grid>
        {inControl.customsRegistrationNumber && (
          <Grid.Col span={3}>
            <Stack gap="xs">
              <Text c="gray" size="sm">
                Customs registration number
              </Text>
              <Text fw={500}>{inControl.customsRegistrationNumber}</Text>
            </Stack>
          </Grid.Col>
        )}
        <Grid.Col span={3}>
          <Stack gap="xs">
            <Text c="gray" size="sm">
              Notification date
            </Text>
            <Text fw={500}>{inControl.notificationDate}</Text>
          </Stack>
        </Grid.Col>
        <Grid.Col span={3}>
          <Stack gap="xs">
            <Text c="gray" size="sm">
              Notification Type
            </Text>
            <Text fw={500}>
              {inControl.notificationType} - {TransitControlNotificationType[inControl.notificationType]}
            </Text>
          </Stack>
        </Grid.Col>
      </Grid>
      {!!inControl.typeOfControls.length && (
        <Stack gap="sm">
          <Title order={5} fw={600}>
            Type of controls
          </Title>
          {inControl.typeOfControls.map((controlType, index) => (
            <Grid key={index}>
              <Grid.Col span={3}>
                <Stack gap="xs">
                  <Text c="gray" size="sm">
                    Type
                  </Text>
                  <Text fw={500}>
                    {controlType.type} - {TransitControlType[controlType.type]}
                  </Text>
                </Stack>
              </Grid.Col>
              <Grid.Col span={5}>
                <Stack gap="xs">
                  <Text c="gray" size="sm">
                    Remarks
                  </Text>
                  <Text fw={500}>{controlType.remarks}</Text>
                </Stack>
              </Grid.Col>
            </Grid>
          ))}
        </Stack>
      )}
      {!!inControl.requestedDocuments.length && (
        <Stack gap="sm">
          <Title order={5} fw={600}>
            Requested documents
          </Title>
          {inControl.requestedDocuments.map((controlType, index) => (
            <Grid key={index}>
              <Grid.Col span={4}>
                <Stack gap="xs">
                  <Text c="gray" size="sm">
                    Type
                  </Text>
                  <Text fw={500}>
                    {controlType.type} - {TransitRequestDocumentType[controlType.type]}
                  </Text>
                </Stack>
              </Grid.Col>
              {controlType.referenceNumber && (
                <Grid.Col span={3}>
                  <Stack gap="xs">
                    <Text c="gray" size="sm">
                      Reference number
                    </Text>
                    <Text fw={500}>{controlType.referenceNumber}</Text>
                  </Stack>
                </Grid.Col>
              )}
              <Grid.Col span={4}>
                <Stack gap="xs">
                  <Text c="gray" size="sm">
                    Description
                  </Text>
                  <Text fw={500}>{controlType.description}</Text>
                </Stack>
              </Grid.Col>
            </Grid>
          ))}
        </Stack>
      )}
    </Stack>
  );
};
